import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { getPageUrl } from 'app/modules/shared/routing'
import { NamedUrlLink } from 'app/modules/admin/features/settings/appearance/types'
import AppbarDropdown from './appbar-dropdown'
import { getActiveSubRouteClass } from './helpers/helpers'

export const DIGEST_ROUTE = 'digest'

export interface ResourcesProps {
  hasDigest: boolean
  extraLinks: NamedUrlLink[]
}

// Shared with the More dropdown, so both menus always list the same links.
export const useResourcesItems = ({ hasDigest, extraLinks }: ResourcesProps): JSX.Element[] => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)

  const items = extraLinks.map((link) => (
    <a key={link.name} className="dropdown-item" href={link.url} target="_blank" rel="noreferrer">
      {link.name}
    </a>
  ))

  if (hasDigest) {
    items.push(
      <Link
        key={DIGEST_ROUTE}
        className={`dropdown-item ${getActiveSubRouteClass(
          [DIGEST_ROUTE],
          currentRoute,
          'appbar-dropdown-item-selected'
        )}`}
        to={getPageUrl('reward-redirect') as string}
      >
        {_t('threat-research-digest')}
      </Link>
    )
  }

  return items
}

const Resources = (props: ResourcesProps): JSX.Element | null => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)
  const items = useResourcesItems(props)

  if (items.length === 0) {
    return null
  }

  return (
    <AppbarDropdown
      className={`appbar-hide-medium ${getActiveSubRouteClass([DIGEST_ROUTE], currentRoute, 'appbar-dropdown-selected')}`}
      title={_t('resources')}
    >
      {items}
    </AppbarDropdown>
  )
}

export default Resources
